import get from 'lodash/get';

/**
 * Custom hook to calculate carousel settings based on viewport
 * @param {Object} sliderSettings - Custom slider settings
 * @param {string} currentBreakpoint - Current viewport breakpoint
 * @param {number} width - Current viewport width
 * @param {boolean} isBelowLg - Whether viewport is below lg breakpoint
 * @returns {Object} Calculated carousel settings
 */
const useCarouselSettings = (sliderSettings, currentBreakpoint, width, isBelowLg) => {
  const defaultSettings = {
    xs: {
      trackSlidesToShow: 3,
      tracksliderGap: 8,
      sliderWidth: width - 32, // 32px is combined padding on left/right
    },
    sm: {
      trackSlidesToShow: 3,
      tracksliderGap: 8,
      sliderWidth: 524,
    },
    md: {
      trackSlidesToShow: 4,
      tracksliderGap: 8,
      sliderWidth: 704,
    },
    lg: {
      trackSlidesToShow: 3,
      tracksliderGap: 8,
      sliderWidth: 620,
    },
    xl: {
      trackSlidesToShow: 4,
      tracksliderGap: 8,
      sliderWidth: 740,
    },
    xxl: {
      trackSlidesToShow: 4,
      tracksliderGap: 8,
      sliderWidth: 870,
    },
  };

  // Use settings passed in, otherwise fallback to default settings
  const trackSlidesToShow = get(sliderSettings[currentBreakpoint], 'trackSlidesToShow', defaultSettings[currentBreakpoint].trackSlidesToShow);
  const sliderWidth = get(sliderSettings[currentBreakpoint], 'sliderWidth', defaultSettings[currentBreakpoint].sliderWidth);
  const trackGap = get(sliderSettings[currentBreakpoint], 'tracksliderGap', defaultSettings[currentBreakpoint].tracksliderGap);

  // Calculate track slide width
  let trackSlideWidth = (sliderWidth - (trackGap * (trackSlidesToShow - 1))) / trackSlidesToShow;

  // On smaller screens, use 90% of slider width to show there are more slides
  if (isBelowLg) {
    trackSlideWidth = ((sliderWidth * 0.9) - (trackGap * (trackSlidesToShow - 1))) / trackSlidesToShow; // eslint-disable-line max-len
  }

  return {
    trackSlidesToShow,
    sliderWidth,
    trackGap,
    trackSlideWidth,
    defaultSettings,
  };
};

export default useCarouselSettings;
